import { render, staticRenderFns } from "./ShortMessage.vue?vue&type=template&id=67d62d0f&scoped=true"
import script from "./ShortMessage.vue?vue&type=script&lang=js"
export * from "./ShortMessage.vue?vue&type=script&lang=js"
import style0 from "./ShortMessage.vue?vue&type=style&index=0&id=67d62d0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d62d0f",
  null
  
)

export default component.exports